import React, { useState } from "react";

const InstallPromptModal = ({
  open,
  onInstall,
  onDismiss,
  onDone,
  error,
  isManualInstall,
  isIos,
  isSafari,
  isIosChrome,
  isMac,
}) => {
  const [showManual, setShowManual] = useState(false);

  if (!open) return null;

  const manualSteps = () => {
    if (isIos || isIosChrome) {
      return (
        <ol className="list-decimal pl-4 text-xs text-gray-700 space-y-2">
          <li>Tap the Share button in Safari.</li>
          <li>Choose "Add to Home Screen".</li>
          <li>Tap "Add" to finish.</li>
        </ol>
      );
    }
    if (isSafari || isMac) {
      return (
        <ol className="list-decimal pl-4 text-xs text-gray-700 space-y-2">
          <li>Click the Share icon in Safari.</li>
          <li>Select "Add to Dock" or "Add to Home Screen".</li>
          <li>Confirm the install.</li>
        </ol>
      );
    }
    return (
      <ol className="list-decimal pl-4 text-xs text-gray-700 space-y-2">
        <li>Open the browser menu.</li>
        <li>Select "Install app".</li>
        <li>Confirm the install.</li>
      </ol>
    );
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-primary/10 flex items-center justify-center">
            <span className="text-primary font-bold">C</span>
          </div>
          <div>
            <p className="text-base font-semibold text-gray-900">
              Install COMTRACKED
            </p>
            <p className="text-xs text-gray-500">
              Get quick access with a desktop or mobile icon.
            </p>
          </div>
        </div>

        <div className="mt-4 rounded-xl bg-gray-50 p-4 text-xs text-gray-600">
          We'll open the app with seamless SSO next time.
        </div>

        {error && (
          <div className="mt-3 rounded-lg border border-amber-200 bg-amber-50 p-3 text-xs text-amber-800">
            {error}
          </div>
        )}

        {isManualInstall ? (
          <div className="mt-4 text-xs text-gray-600">
            Your browser needs a manual install step.
          </div>
        ) : null}

        <div className="mt-6 flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={onDismiss}
            className="rounded-lg border border-gray-200 px-4 py-2 text-xs font-medium text-gray-700 hover:bg-gray-100"
          >
            Dismiss
          </button>
          {isManualInstall ? (
            <>
              <button
                type="button"
                onClick={() => setShowManual(true)}
                className="rounded-lg border border-gray-300 px-4 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-100"
              >
                Show Steps
              </button>
              <button
                type="button"
                onClick={onDone}
                className="rounded-lg bg-primary px-4 py-2 text-xs font-semibold text-white hover:bg-primary/90"
              >
                Done it
              </button>
            </>
          ) : (
            <button
              type="button"
              onClick={onInstall}
              className="rounded-lg bg-primary px-4 py-2 text-xs font-semibold text-white hover:bg-primary/90"
            >
              Install
            </button>
          )}
        </div>

        {showManual ? (
          <div className="mt-5 rounded-xl border border-gray-200 bg-white p-4">
            <div className="flex items-center justify-between mb-3">
              <p className="text-sm font-semibold text-gray-900">
                Install steps
              </p>
              <button
                type="button"
                onClick={() => setShowManual(false)}
                className="text-xs text-gray-500 hover:text-gray-700"
              >
                Close
              </button>
            </div>
            {manualSteps()}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default InstallPromptModal;
